import { Box, Button } from '@mui/material';
import PropTypes from 'prop-types';
import Iconify from '../iconify';

DropdownAction.propTypes = {
  children: PropTypes.node.isRequired,
  buttonComponent: PropTypes.elementType,
  iconColor: PropTypes.string,
  iconBgColor: PropTypes.string,
  textColor: PropTypes.string,
  sx: PropTypes.object,
  badgeIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default function DropdownAction({
  badgeIcon,
  children,
  buttonComponent: ButtonComponent = Button,
  iconColor = 'text.secondary',
  iconBgColor = 'grey.200',
  textColor = 'grey.700',
  sx = {},
  ...buttonProps
}) {
  return (
    <ButtonComponent
      fullWidth
      size="small"
      variant="text"
      startIcon={
        badgeIcon ? (
          <Box
            className="dropdown-action-icon"
            sx={{
              width: 28,
              height: 28,
              borderRadius: 1,
              bgcolor: iconBgColor,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              transition: 'background-color .15s',
            }}
          >
            <Iconify icon={badgeIcon} width={18} sx={{ color: iconColor }} />
          </Box>
        ) : undefined
      }
      sx={{
        justifyContent: 'flex-start',
        color: textColor,
        textTransform: 'none',
        height: 40,
        borderRadius: 1,
        pl: badgeIcon ? 2 : 5,
        pr: 2,
        '& .MuiButton-startIcon': {
          mr: 1.5,
        },
         '& .MuiButton-endIcon': {
          ml: 'auto',
        },
        '&:hover': {
          bgcolor: 'grey.200',
        },
        '&:hover .dropdown-action-icon': {
          bgcolor: 'grey.200',
        },
        ...sx,
      }}
      {...buttonProps}
    >
      {children}
    </ButtonComponent>
  );
}